module.exports = __webpack_public_path__ + "img/banner_bg.4ded0d8a.png";